import { DateUtils } from "react-day-picker";

export const isDayShouldBeDisabled = ({ includeDates, minDate, maxDate }) => {
  const conditionals = [];

  if (includeDates && includeDates.length) {
    // returns true if includeDates do not contain 'day'
    conditionals.push(day =>
      includeDates.every(includeDate => !DateUtils.isSameDay(day, includeDate))
    );
  }
  if (minDate) {
    // returns true if 'day' is before 'minDate'
    conditionals.push(day => DateUtils.isDayBefore(day, minDate));
  }
  if (maxDate) {
    // returns true if 'day' is after 'maxDate'
    conditionals.push(day => DateUtils.isDayAfter(day, maxDate));
  }
  // returns true if 'day' failed some conditional
  return day => conditionals.some(conditional => conditional(day));
};
